import React from "react";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";

import { Recording } from "lib/build/recordings";

import { Field } from "src/common/components/Field";
import { Select } from "src/common/components/Select";
import { useFormatName } from "src/common/hooks/useFormatName";
import { useKnownUsers } from "src/features/auth";

const messages = defineMessages({
	formList: {
		id: "form.examination_list.list_of_filled_forms",
		defaultMessage: "Kitöltött űrlapok listája"
	},
	newForm: {
		id: "form.examination_list.fill_in_a_new_form",
		defaultMessage: "Új űrlap kitöltése"
	}
});

interface ExaminationsProps {
	recordings: Recording[];
	version: string | undefined;
	onChangeVersion(version: string | undefined): unknown;
}

export const Examinations: React.FunctionComponent<ExaminationsProps> = ({
	recordings,
	version,
	onChangeVersion
}) => {
	const { formatMessage, formatDate } = useIntl();

	const users = useKnownUsers();
	const formatName = useFormatName();

	const options = React.useMemo(
		() =>
			recordings.map(({ modifUser: userId = "", version, timestamp }) => {
				let label = formatDate(timestamp, {
					year: "numeric",
					month: "numeric",
					day: "numeric",
					hour: "numeric",
					minute: "numeric",
					second: "numeric"
				});
				if (userId in users) {
					label += ` - ${formatName(users[userId])}`;
				}
				return { value: version, label };
			}),
		[recordings, users, formatDate, formatName]
	);

	return (
		<Field label={<FormattedMessage {...messages.formList} />}>
			<Select
				placeholder={formatMessage(messages.newForm)}
				value={version}
				onChangeValue={onChangeVersion}
				options={options}
			/>
		</Field>
	);
};
